<template>
  <v-row>
    <v-col cols="12">
      <Filtro/>
    </v-col>

    <v-col cols="12">
      <TableVeiculos/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Veiculos',

  components: {
    Filtro: () => import("./components/Filtro"),
    TableVeiculos: () => import("./components/TableVeiculos")
  }
}
</script>
